import { render, staticRenderFns } from "./navigationSideView.vue?vue&type=template&id=347523c4&scoped=true"
import script from "./navigationSideView.vue?vue&type=script&lang=js"
export * from "./navigationSideView.vue?vue&type=script&lang=js"
import style0 from "./navigationSideView.vue?vue&type=style&index=0&id=347523c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347523c4",
  null
  
)

export default component.exports